interface BeatStarsMarketplaceProps {
  height: number;
}

const BeatStarsMarketplace = ({ height }: BeatStarsMarketplaceProps) => {
  return (
    <iframe
      src="https://player.beatstars.com/?storeId=55549"
      title="BeatStars Marketplace"
      width="100%"
      height={height}
      className="playerBorder"
    />
  );
};

export default BeatStarsMarketplace;
